import _get from 'lodash.get';
import _set from 'lodash.set';

import PURPOSES from '../definitions/Purpose';


const MAPPINGS_BY_TRANSACTION_TYPE = {
    [PURPOSES.PURCHASE]: {
        [PURPOSES.RENEWAL]: [
            { oldPath: 'mortgage.purchasePrice', newPath: 'subjectProperty.homeValue' },
        ],
        [PURPOSES.REFINANCE]: [
            { oldPath: 'mortgage.purchasePrice', newPath: 'subjectProperty.homeValue' },
        ],
        [PURPOSES.HELOC]: [
            { oldPath: 'mortgage.purchasePrice', newPath: 'subjectProperty.homeValue' },
        ],
    },
    [PURPOSES.RENEWAL]: {
        [PURPOSES.PURCHASE]: [
            { oldPath: 'subjectProperty.homeValue', newPath: 'mortgage.purchasePrice' },
        ],
    },
    [PURPOSES.REFINANCE]: {
        [PURPOSES.PURCHASE]: [
            { oldPath: 'subjectProperty.homeValue', newPath: 'mortgage.purchasePrice' },
        ],
    },
    [PURPOSES.HELOC]: {
        [PURPOSES.PURCHASE]: [
            { oldPath: 'subjectProperty.homeValue', newPath: 'mortgage.purchasePrice' },
        ],
    },
};

/**
 * Given old transaction type, mutate provided journey and re-map anything specified by table above for specified new transaction type.
 *
 * @param journey
 * @param oldTransactionType
 * @param newTransactionType
 */
function remapJourneyToTransactionType(journey, oldTransactionType, newTransactionType) {
    const mappings = getMappings(oldTransactionType, newTransactionType);

    mappings.forEach(({ oldPath, newPath }) => {
        const oldValue = _get(journey, oldPath);

        _set(journey, newPath, oldValue);
    });
}

function getMappings(oldTransactionType, newTransactionType) {
    const availableMappings = MAPPINGS_BY_TRANSACTION_TYPE[oldTransactionType];

    return availableMappings[newTransactionType] ?? []; // assume no mappings
}

export default remapJourneyToTransactionType;
